import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  SelectControlValueAccessor,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UpdateService } from 'src/app/core/service/update-password/update.service';
import { MustMatch } from 'src/app/shared/directives/confirmed.validator.directive';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css'],
})
export class UpdatePasswordComponent implements OnInit {
  passregex = '(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?=*&]).{8,}';
  showPassword: boolean;
  userId: any;
  hide: boolean;
  updateForm: FormGroup;
  submitted = false;
  disableBtn: boolean = false;

  constructor(
    private fb: FormBuilder,
    private updateService: UpdateService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.disableBtn = false;
    this.formInit();
    this.userId = this.route.snapshot.queryParams.id;
    this.onSuccess(this.userId);
  }
  formInit(): void {
    this.updateForm = this.fb.group(
      {
        password: [
          '',
          [Validators.required, Validators.pattern(this.passregex)],
        ],
        confirmPassword: ['', [Validators.required]],
      },

      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );
  }

  get f() {
    return this.updateForm.controls;
  }
  // Login Method
  onpasswordUp(): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.updateForm.invalid) {
      return;
    }
    const val = this.updateForm.value;
    // console.log(val, 'hari');
    const took = location.search;
    // console.log(took, 'vishnu');

    const tok = took.substring(
      took.indexOf('token=') + 6,
      took.indexOf('&id=')
    );
    const id = took.substring(took.indexOf('id=') + 3, took.indexOf('&role='));
    const user = took.substring(took.indexOf('role=') + 5);

    val.token = tok;
    val.userId = id;
    val.role = user;
    this.disableBtn = true;
    this.updateService.updatePassword(this.updateForm.value).subscribe(
      (res) => {
        if (res.message == 'successfully password reseted.') {
        }
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
        setTimeout(() => {
          this.router.navigateByUrl('/login');
          this.disableBtn = false;
        }, 5000);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.message,
        });
      }
    );
    setInterval(() => {
      this.disableBtn = false;
    }, 5000);
  }
  submit() {
    console.log(this.updateForm.value);
  }
  toggleFieldTextType() {
    this.showPassword = !this.showPassword;
  }
  togglePasswordType() {
    this.hide = !this.hide;
  }
  showValidat() {
    //   Swal.fire({
    //     title: 'Password validation!',
    //     text: ' Minimum 8 and maximum 10 character,atleast 1 uppercase,1 lowercase,1 number,1 special character',
    //     icon: 'info',
    //     confirmButtonText: 'ok'
    //   })
    // }
  }
  onSuccess(id) {
    if (environment.mode == 'online') {
      const ten = {
        userId: id,
      };
      this.updateService.token(ten).subscribe(
        (data) => {
          console.log(data);
          // this.router.navigateByUrl('/login');
        },
        (error) => {
          /*this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Session Expired',
          });*/
          if (error.status == 0) {
            console.log(error);
            setTimeout(() => {
              this.router.navigateByUrl('/login');
            }, 5000);
          }
        }
      );
    } else {
      this.router.navigateByUrl('/update-password');
    }
  }
}
